import React from "react";
import {
  UpdateLessonMutationVariables,
  useLessonQuery,
  useUpdateLessonMutation,
} from "../../generated/graphql";
import { useToast } from "@chakra-ui/react";
import Loading from "../../components/loading/Loading";
import { Navigate, useNavigate } from "react-router-dom";
import Form from "./Form";

interface Props {
  id: string;
}

const Update: React.VFC<Props> = ({ id }) => {
  const [updateLesson] = useUpdateLessonMutation();
  const navigation = useNavigate();
  const toast = useToast();

  const { loading, error, data } = useLessonQuery({
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Navigate to={"/lesson"} replace />;
  }

  const handleUpdateLesson = async (data: UpdateLessonMutationVariables) => {
    try {
      await updateLesson({
        variables: {
          ...data,
        },
      });

      return toast({
        status: "success",
        title: "Success",
        description: "Lesson updated",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/lesson");
        },
      });
    } catch (error: any) {
      console.log(error.message);
      return toast({
        status: "error",
        title: "Error",
        description: "An error occured",
        duration: 1000,
      });
    }
  };

  return (
    <Form
      actionType="UPDATE"
      data={data?.lesson}
      id={id}
      handleUpdateLesson={handleUpdateLesson}
    />
  );
};

export default Update;
